export class Aditional {

  id: number;
  companyId: number;
  clientId: number;
  categoryId: number;
  categoryName: string;
  name: string;
  description: string;
  stackable: boolean;
  stackValue: number;
  value: number;
  stock: number;
  selected: boolean;

	constructor( a ?: any) {
		this.id           = a ? a.id : null;
    this.companyId    = a ? a.company_id : null;
    this.clientId     = a ? a.client_id : null;
    this.categoryId   = a ? a.category_id : null;
    this.categoryName = a ? a.category_name : null;
    this.name         = a ? a.name : null;
    this.description  = a ? a.description : null;
    this.stackable    = a ? a.stackable : null;
    this.stackValue   = 0;
    this.value        = a ? a.value : null;
    this.stock        = a ? a.stock : null;
    this.selected     = false;
  }
  
  mapAditional(list: any[]): Aditional[] {
    let newList: Aditional[] = [];
    list.forEach((item: any) => {
      let newItem: Aditional = new Aditional(item);
      newList.push(newItem);
    });
    return newList;
  }

}
